import React, { Component } from 'react';
import { Icon, Select } from 'antd';

import { observer, inject } from 'mobx-react';

import { isFunction } from 'lodash';

@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class DealerFilter extends Component {
  keyStorage = `carFilter_dealer`;

  constructor(props) {
    super(props);

    this.state = {
      selectedDealer: null
    };
  }

  componentDidMount() {
    const { carsStore } = this.props;
    if (carsStore.dealers) {
      this.initDealer();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status == !this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  initDealer = () => {
    const { filterStore } = this.props;
    if (filterStore.appliedFiltersParameters && filterStore.appliedFiltersParameters.hasOwnProperty(this.keyStorage)) {
      const { selectedDealer } = filterStore.appliedFiltersParameters[this.keyStorage];
      this.setState({ selectedDealer });
    }
  };

  selectDealer = dealerId => {
    const { filterStore } = this.props;
    this.setState({ selectedDealer: dealerId });
    if (dealerId) {
      filterStore.add('carFilter_dealer', car => car.dealerId === dealerId, undefined, { selectedDealer: dealerId });
    } else {
      filterStore.remove('carFilter_dealer');
    }
  };

  removeDealer = () => {
    const { filterStore } = this.props;
    this.setState({ selectedDealer: null });
    filterStore.remove('carFilter_dealer');
    filterStore.apply();
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        selectedDealer: null
      });
    }
  };

  render() {
    const { selectedDealer } = this.state;
    const { translationsStore, carsStore } = this.props;
    return (
      <div id="dealerFilter">
        <div className="filterTitle">
          {translationsStore.translate('carList.filters.filter.dealer')}
          <span>
            {!!selectedDealer && (
              <span>
                {(carsStore.dealers.find(dealer => dealer.id===selectedDealer)||{}).name}
                <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.removeDealer} />
              </span>
            )}
          </span>
        </div>
        <Select value={selectedDealer} getPopupContainer={() => document.getElementById('dealerFilter')} onChange={this.selectDealer}>
          {carsStore.dealers.map(dealer => (
            <Select.Option value={dealer.id} key={dealer.id}>
              {dealer.name}
            </Select.Option>
          ))}
        </Select>
      </div>
    );
  }
}
